import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { MediaUpload } from '../media/MediaUpload';
import { MediaGallery } from '../media/MediaGallery';
import { Plus } from 'lucide-react';

interface MediaSectionProps {
  userId: string;
  isOwnProfile: boolean;
}

export const MediaSection = ({ userId, isOwnProfile }: MediaSectionProps) => {
  const [showUpload, setShowUpload] = useState(false);

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Media</CardTitle>
        {isOwnProfile && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => setShowUpload(!showUpload)}
          >
            <Plus className="h-4 w-4 mr-2" />
            {showUpload ? 'Cancel' : 'Add Media'}
          </Button>
        )}
      </CardHeader>
      <CardContent>
        {showUpload && <MediaUpload />}
        <div className={showUpload ? 'mt-6' : ''}>
          <MediaGallery userId={userId} />
        </div>
      </CardContent>
    </Card>
  );
};